import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';

import { UserProfile, AuthService, Permission } from '@olv/ui-shared/services/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './developer.component.html',
  styleUrls: ['./developer.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatCardModule, MatButtonModule, MatIconModule, MatToolbarModule, MatListModule, RouterModule],
})
export class DeveloperComponent implements OnInit {
  private authService = inject(AuthService);

  user: UserProfile | null = null;

  ngOnInit(): void {
    this.authService.currentUser$.subscribe((user) => {
      this.user = user;
    });
  }

  getUserName(): string {
    return this.user?.name || this.user?.username || 'User';
  }

  getUserEmail(): string {
    return this.user?.email || '';
  }

  hasRoles(): boolean {
    return !!(this.user?.roles && this.user.roles.length > 0);
  }

  getRoles(): string[] {
    return this.user?.roles || [];
  }

  getPermissions(): Permission[] {
    return this.user?.permissions || [];
  }

  hasPermissions(): boolean {
    return !!(this.user?.permissions && this.user.permissions.length > 0);
  }

  refreshToken(): void {
    this.authService.refreshToken().subscribe();
  }
}
